import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { ITwitterPostDetailsPutDto } from '../Models/ITwitterPostDetailsPutDto';
import { TwitterPostsPaginationResponse, IGetTwitterPostsData } from '../Models/ITwitterPost';
import {  ITwitterComment } from '../Models/ITwitterComment';
import { environment } from '../../../../environments/environment';
import { IApiResponseDto, IFilterBody, IPagination, IPolitician, IPostType, ITopic } from '../../../helpers/general.interface';
import { HelperFunctions } from '../../../helpers/HelperFunctions';


@Injectable({
  providedIn: 'root'
})
export class TwitterService {
  constructor(private http: HttpClient) {}

  
public getAllPosts(pagination: IPagination, sortBy: string, sortDir: string, searchVal: string, filters: IFilterBody[]): Observable<TwitterPostsPaginationResponse> {
  let params: HttpParams = new HttpParams();
  
  if (pagination) {
    params = HelperFunctions.addPaginationToParams(params, pagination);
  }
  
  if (sortBy)
    params = params.set('sortBy', sortBy);
  
  if (sortDir)
    params = params.set('sortDir', sortDir);
  
  if (searchVal)
    params = params.set('searchVal', searchVal);
  
  return this.http.post<TwitterPostsPaginationResponse>(
    `${environment.twitterUrl}/twitter`,
    filters || [],
    { params: params }
  );
}


   public updatePostDetails(body: ITwitterPostDetailsPutDto): Observable<IApiResponseDto> {
    let response: Observable<IApiResponseDto> = this.http.put<IApiResponseDto>(`${environment.twitterUrl}/twitter/details`, body)
    return response
   }


   public getPostDetails(id: string): Observable<IGetTwitterPostsData> {
    return this.http.get<IGetTwitterPostsData>(`${environment.twitterUrl}/twitter/${id}/details`);
  }

   public getPostComments(id: string): Observable<ITwitterComment[]> {

    let response: Observable<ITwitterComment[]> = this.http.get<ITwitterComment[]>(`${environment.twitterUrl}/comment/${id}/list`)
    return response
   }


   public getCommentDetails(id: string): Observable<ITwitterComment> {

    let response: Observable<ITwitterComment> = this.http.get<ITwitterComment>(`${environment.twitterUrl}/comment/${id}/details`)
    return response
   }


   public getPoliticians(): Observable<IPolitician[]> {
    let response = this.http.get<IPolitician[]>(`${environment.twitterUrl}/politician/list`);
    return response;
   }

    public getHashtags(): Observable<string[]> {
    let response = this.http.get<string[]>(`${environment.twitterUrl}/politician/hashtags/list`);
    return response;
   }


   public getPoliticianDetails(politicianId: string): Observable<IPolitician> {
    let response = this.http.get<IPolitician>(`${environment.twitterUrl}/politician/${politicianId}/details`);
    return response;
   }
  
   public getAttackedPoliticians(): Observable<IPolitician[]> {
     return this.http.get<string[]>(`${environment.twitterUrl}/politician/attacked-politicians/list`)
       .pipe(
          map(response => response.map(item => ({
            name: item,
            id: item
        } as IPolitician))));
   }

   public getPostTypes(): Observable<IPostType[]> {

    let response: Observable<IPostType[]> = this.http.get<IPostType[]>(`${environment.twitterUrl}/post-type/list`)
    return response
   }


   public getPostTopics(): Observable<ITopic[]> {

    let response: Observable<ITopic[]> = this.http.get<ITopic[]>(`${environment.twitterUrl}/topic/list`)
    return response
   }
}